import { __extends } from "tslib";
import { deserializeAws_json1_1StartTextTranslationJobCommand, serializeAws_json1_1StartTextTranslationJobCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartTextTranslationJobCommand = /** @class */ (function (_super) {
    __extends(StartTextTranslationJobCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartTextTranslationJobCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartTextTranslationJobCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartTextTranslationJobCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartTextTranslationJobCommand(input, context);
    };
    StartTextTranslationJobCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartTextTranslationJobCommand(output, context);
    };
    return StartTextTranslationJobCommand;
}($Command));
export { StartTextTranslationJobCommand };
//# sourceMappingURL=StartTextTranslationJobCommand.js.map